import { Trash2 } from "lucide-react"

import { Button } from "@/components/ui/button"
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog"

// Shared discard-confirm for the multi-draft surfaces (design discardModal(),
// enumerated state E4). One DS Dialog, reused by the Projects strip and the
// split entry — no window.confirm, no hand-rolled overlay (tuw-app:P-010).
//
// Controlled: the parent holds the draft being discarded (null = closed). On
// confirm it calls onConfirm(draft); discarding itself (DELETE /post/drafts/:id
// via discardDraft) and the post-discard reload stay with the parent, since each
// surface reloads a different set of props.
export default function DiscardDraftDialog({ draft, onOpenChange, onConfirm }) {
  const open = !!draft

  return (
    <Dialog open={open} onOpenChange={(next) => !next && onOpenChange(false)}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2">
            <span className="grid size-9 shrink-0 place-items-center rounded-[11px] border border-border bg-secondary">
              <Trash2 className="size-4 text-destructive" strokeWidth={2} />
            </span>
            Discard this draft?
          </DialogTitle>
          <DialogDescription>
            <b className="font-semibold text-foreground">{draft?.name || "This draft"}</b> and
            everything you set up will be permanently removed. This can&rsquo;t be undone.
          </DialogDescription>
        </DialogHeader>
        <DialogFooter>
          <Button variant="outline" onClick={() => onOpenChange(false)}>
            Keep draft
          </Button>
          <Button variant="destructive" onClick={() => draft && onConfirm(draft)}>
            Discard draft
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
}
